import * as React from "react";
import { SVGProps, memo } from "react";

const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="Link_svg__a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={3}
      width={14}
      height={14}
    >
      <rect x={3.5} y={3.5} width={13} height={13} rx={1.5} stroke="#272C33" />
    </mask>

    <g mask="url(#Link_svg__a)" fill="#272C33">
      <path d="M13 3h4v14h-4V3Z" />

      <path d="M3 13h14v4H3v-4Z" />
    </g>

    <rect x={0.5} y={0.5} width={13} height={13} rx={1.5} stroke="#272C33" />
  </svg>
);

const Memo = memo(SvgLink);

export default Memo;
